import React, { useState, useEffect } from 'react';
import styles from './AddRoleModal.module.scss';
import Modal from '../../../layout/modal/Modal';
import {
	TextField,
	Grid,
	FormControl,
	Select,
	MenuItem,
	InputLabel,
	Button,
} from '@mui/material';
import { closeModal } from '../../../../redux/modals/action';
import { connect } from 'react-redux';
import CustomButton from '../../../layout/customButton/CustomButton';
import UserAccessibility from '../userAccessibility/UserAccessibility';
import { getAccessibilitiesByRoles } from '../../../../redux/userManagement/actions';
import ColorSelector from '../colorSelector/ColorSelector';
import { createRole } from '../../../../api/UserManagement/createRole.api';
import { editRole } from '../../../../api/UserManagement/editRole.api';
import { setAlert } from '../../../../redux/alerts/action';

const AddRoleModal = (props) => {
	const {
		showModal,
		closeModal,
		roles,
		getAccessibilitiesByRoles,
		projectSelectedCode,
		roleSelected,
		setRoleSelected,
		setAlert,
	} = props;
	const [roleName, setRoleName] = useState('');
	const [color, setColor] = useState('');
	const [accessibilityCheckbox, setAccessibilityCheckbox] = useState({});
	const [defaultRole, setDefaultRole] = useState('');

	useEffect(() => {
		if (roleSelected) {
			let filteredRole = roles.filter(
				(role) => role.roleId === roleSelected
			);
			if (filteredRole.length > 0) {
				setRoleName(filteredRole[0].roleName);
				setColor(filteredRole[0].roleColor);
				setDefaultRole(roleSelected);
				getAccessibilitiesByRoles(projectSelectedCode, roleSelected);
			}
		} else {
			setRoleName('');
			setColor('');
			setDefaultRole('');
			getAccessibilitiesByRoles(projectSelectedCode, '');
		}
	}, [roleSelected]);

	const handleCloseModal = () => {
		closeModal('addRole');
		setRoleSelected();
	};

	const handleChangeRoleInfo = (event) => {
		if (event.target.name === 'role name') {
			setRoleName(event.target.value);
		} else if (event.target.name === 'color') {
			setColor(event.target.value);
		} else if (event.target.name === 'default role') {
			setDefaultRole(event.target.value);
			getAccessibilitiesByRoles(projectSelectedCode, event.target.value);
		}
	};

	const handleAddRole = async () => {
		if (!roleName) {
			setAlert('error', 'The role name cannot be empty.');
			return;
		}
		if (!color) {
			setAlert('error', 'The color cannot be empty.');
			return;
		}

		let result = await createRole(
			projectSelectedCode,
			roleName,
			accessibilityCheckbox,
			color
		);

		if (result.success) {
			handleCloseModal();
			setAlert('success', 'Add role successfully.');
		} else {
			if (result.roleIdExist) {
				setAlert(
					'error',
					'Try another role name because the role id for this name might be used.'
				);
			} else {
				setAlert('error', 'Failed to create role.');
			}
		}
	};

	const handleEditRole = async () => {
		if (!roleName) {
			setAlert('error', 'The role name cannot be empty.');
			return;
		}
		if (!color) {
			setAlert('error', 'The color cannot be empty.');
			return;
		}

		let result = await editRole(
			projectSelectedCode,
			roleSelected,
			roleName,
			accessibilityCheckbox,
			color
		);

		if (result.success) {
			handleCloseModal();
			setAlert('success', 'Edit role successfully.');
		} else {
			setAlert('error', 'Failed to edit role.');
		}
	};

	return (
		<div className={styles.add_role}>
			<Modal
				show={showModal}
				close={handleCloseModal}
				title={
					roleSelected
						? 'Edit New Role Preset'
						: 'Add New Role Preset'
				}
			>
				<Grid container spacing={1} className={styles.role_form}>
					<Grid item xs={6}>
						<TextField
							fullWidth
							label='role name'
							name='role name'
							value={roleName}
							onChange={handleChangeRoleInfo}
						/>
					</Grid>
					<Grid item xs={6}>
						<ColorSelector color={color} setColor={setColor} />
					</Grid>
					<Grid item xs={6}>
						<FormControl fullWidth>
							<InputLabel id='default-role'>
								default role
							</InputLabel>
							<Select
								labelId='default-role'
								value={defaultRole}
								label='default role'
								name='default role'
								onChange={handleChangeRoleInfo}
							>
								{roles.map((role, index) => (
									<MenuItem value={role.roleId} key={index}>
										{role.roleName}
									</MenuItem>
								))}
								<MenuItem value=''>None</MenuItem>
							</Select>
						</FormControl>
					</Grid>
				</Grid>
				<div className={styles.user_accessibility}>
					<div className={styles.user_accessibility_section}>
						<h3 className={styles.user_accessibility_title}>
							User Accessibility
						</h3>
						<UserAccessibility
							accessibilityCheckbox={accessibilityCheckbox}
							setAccessibilityCheckbox={setAccessibilityCheckbox}
						/>
						<div className={styles.footer_btn_group}>
							<Button className={styles.cancel_btn}>
								Cancel
							</Button>
							{roleSelected ? (
								<CustomButton
									width={166}
									height={42}
									onClick={handleEditRole}
								>
									Edit
								</CustomButton>
							) : (
								<CustomButton
									width={166}
									height={42}
									onClick={handleAddRole}
								>
									Add
								</CustomButton>
							)}
						</div>
					</div>
				</div>
			</Modal>
		</div>
	);
};

const mapStateToProps = (state) => ({
	roles: state.userManagement.roles,
	projectSelectedCode: state.userManagement.projectSelectedCode,
});

export default connect(mapStateToProps, {
	closeModal,
	getAccessibilitiesByRoles,
	setAlert,
})(AddRoleModal);
